import React, { useContext, useEffect, useState, FC } from 'react';

import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';

import { GlobalContext } from '../../../../store';

import { useAssignResultsState } from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { useGetRoundLabel } from '../../../common/Hooks/useGetroundLabel';
import { useEventLeaderboardsState } from '../Context/EventLeaderboards.context';
import { useLeaderboardsResults } from '../../../common/Hooks/useLeaderboardsResults';
import { displayPosition } from '../../../../contrib/Utils/displayPosition';
import { displayScore } from '../../../../contrib/Utils/displayScore';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import RoundScoreSummary from '../TeamFormatTable/Component/RoundScoreSummary/RoundScoreSummary';
import { getTeamGameIndex } from '../../../../contrib/Utils/getTeamGameIndex';

export const MoneyBallTable: FC = () => {
  const {
    actions: {
      teamHoleResults: { get: getTeamHoleResults }
    },
    events,
    adminTeamResults,
    teamHoleResults
  } = useContext(GlobalContext);

  const { selectedScoreType, selectedRoundFormat } = useAssignResultsState();
  const { selectedRound, selectedFlightId } = useEventLeaderboardsState();
  const { eventId, roundId } = useRouteInfoState();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [formatIsStableford, setFormatIsStableford] = useState(false);

  const handleChangePage = (_EVENT: any, pageNumber: number) => {
    setPage(pageNumber);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(event.target.value);
  };

  useEffect(() => {
    if (selectedRoundFormat) {
      setFormatIsStableford(selectedRoundFormat.scoringFormat === 1);
    }
  }, [selectedRoundFormat]);

  const [sortedResults, formattedTeamsHoleResults] = useLeaderboardsResults({
    adminTeamHoleResults: teamHoleResults,
    adminTeamResults,
    formatIsStableford,
    roundId: roundId ? Number(roundId) : 0,
    selectedFlightId,
    selectedScoreType,
    selectedTeamFormat: 'moneyBall'
  });

  const columnNumber = [0, 1, 2, 3];

  const [getRoundLabel] = useGetRoundLabel(events, Number(eventId), Number(roundId));

  const [collapsedRow, setCollapsedRow] = useState<null | number>(null);

  const onClick = (index: number) => () => setCollapsedRow(collapsedRow === index ? null : index);

  useEffect(() => {
    setCollapsedRow(null);
  }, [selectedScoreType, selectedFlightId]);

  useEffect(() => {
    getTeamHoleResults(roundId);
  }, [roundId]);

  return (
    <div className="event-leaderboards-table">
      <Table className="leaderboard-score-table">
        <colgroup>
          {columnNumber.map(index => (
            <col key={index} />
          ))}
        </colgroup>
        <TableHead className="leaderboard__thead">
          <TableRow className="leaderboard-header">
            <TableCell className="leaderboard-header__cell override index">Pos</TableCell>

            <TableCell className="leaderboard-header__cell override playerName">TEAM</TableCell>

            <TableCell
              className={`leaderboard-header__cell override result ${!selectedRound ? 'rpad' : ''}`}
            >
              {getRoundLabel()}
            </TableCell>

            <TableCell className="leaderboard-header__cell override through">THRU</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="leaderboard__tbody">
          {sortedResults && sortedResults.length > 0 ? (
            sortedResults
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((teamResult, index: number) => [
                <TableRow
                  id={`clickableRowResult-${index}`}
                  key={`tableRowResult-${index}`}
                  onClick={onClick(index)}
                >
                  <TableCell className="index">
                    {displayPosition(teamResult, 'moneyBall', selectedScoreType)}
                  </TableCell>

                  <TableCell className="playerName">{teamResult.teamName}</TableCell>

                  <TableCell className="result">
                    {displayScore(teamResult, 'moneyBall', selectedScoreType).replace('+', '-')}
                  </TableCell>

                  <TableCell className="through">{teamResult.through}</TableCell>
                </TableRow>,
                <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
                  <TableCell
                    className="inner-cell"
                    colSpan={selectedRound ? 5 : 4}
                    classes={{ root: 'leaderboard-row-event-summary' }}
                  >
                    <Collapse
                      className={`collapse-${index}`}
                      classes={{
                        container: 'leaderboard-collapse',
                        wrapperInner: 'leaderboard-collapse__wrapper-inner override'
                      }}
                      in={collapsedRow === index}
                      timeout="auto"
                      unmountOnExit={true}
                    >
                      {selectedScoreType && (
                        <RoundScoreSummary
                          itemHandicap={getTeamGameIndex(
                            events,
                            eventId,
                            roundId,
                            teamResult.groupId,
                            teamResult.teamId
                          )}
                          playerScores={
                            formattedTeamsHoleResults
                              ? formattedTeamsHoleResults[teamResult.teamGameId]
                              : undefined
                          }
                          range={{ start: 0, length: 18 }}
                          scoreType={selectedScoreType}
                          hideHandicapsRow={true}
                        />
                      )}
                    </Collapse>
                  </TableCell>
                </TableRow>
              ])
          ) : (
            <TableRow>
              <TableCell colSpan={4} className="no-results">
                No results to show
              </TableCell>
            </TableRow>
          )}
        </TableBody>

        <TableFooter>
          <TablePagination
            rowsPerPageOptions={[200, 250, 300]}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
            count={sortedResults.length}
          />
        </TableFooter>
      </Table>
    </div>
  );
};
